import styled from 'styled-components';

export const Wrapper = styled.div`
  height: 60px;
  padding: 15px 70px;
  background-color: ${({ theme }) => theme.background};
  display: flex;
  .header-text {
    padding: 0 10px;
  }
`;
